// src/index.tsx
// ---------------------------------------------------------------------------
// IMPORTANT: This file must NOT import React or any shared dependency directly.
// The dynamic import below is the Module Federation bootstrap pattern — it
// ensures Webpack's shared scope is initialised before any shared singleton
// (react, msal, etc.) is loaded.
// ---------------------------------------------------------------------------
import './styles.css';
import('./bootstrap');
